import { FIELD_IS_VALID } from '../../../Constants';

const facultyDepartmentValidation = (facultyDepartment) => {
  if (!facultyDepartment) {
    return 'collection_validation_faculty_department_is_required';
  }

  return FIELD_IS_VALID;
};

export default facultyDepartmentValidation;
